import { render, staticRenderFns } from "./McrAllForm.vue?vue&type=template&id=1ca09b9b"
import script from "./McrAllForm.vue?vue&type=script&lang=js"
export * from "./McrAllForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports